<template>
  <!-- The Modal -->
  <div
    id="myModal"
    class="modal"
    tabindex="0"
    @keydown.esc="closeModal()"
    :class="{
      active: isOpen,
      'sidebar-open': isSidebarOpen,
      'assistant-docked': isAssistantDocked,
      'full-page': fullPage
    }"
  >
    <div
      v-if="!fullPage"
      class="modal-bg"
      @click="
        {
          if (clickOutsideClose) {
            closeModal();
          }
        }
      "
    ></div>
    <!-- Modal content -->
    <div class="modal-content flex flex-col">
      <div
        class="header"
        v-if="existHeader && showHeader"
        :class="{ hasinfo: existHeader }"
      >
        <div class="info" v-if="existHeader">
          <slot name="header"></slot>
        </div>
        <span @click="closeModal()" class="close px-4" v-if="allowClose"
          >&times;</span
        >
      </div>
      <span @click="closeModal()" class="close px-4" v-else-if="allowClose"
        >&times;</span
      >
      <div class="content w-full flex-grow">
        <slot />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "modalComponent",
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false
    },
    allowClose: {
      type: Boolean,
      required: false,
      default: true
    },
    clickOutsideClose: {
      type: Boolean,
      required: false,
      default: true
    },
    showHeader: {
      type: Boolean,
      required: false,
      default: true
    },
    fullPage: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    ...mapGetters("general", ["getStatusMenu", "getAssistantDocked"]),
    existHeader() {
      return !!this.$slots.header;
    },
    isOpen() {
      return this.value;
    },
    isSidebarOpen() {
      return this.getStatusMenu;
    },
    isAssistantDocked() {
      return this.getAssistantDocked;
    }
  },
  watch: {
    isOpen(val) {
      if (val) {
        this.$nextTick(() => {
          document.getElementById("myModal").focus();
        });
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit("input", !this.isOpen);
    }
  }
};
</script>
<style lang="scss">
/* The Modal (background) */
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 100; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: visible; /* Allow content to grow without scroll */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  transition: left 0.3s ease-in-out;

  &:focus {
    border: none;
    outline: none;
  }
  .modal-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
  }

  /* Adjust modal when sidebar is expanded */
  &.sidebar-open {
    @media (min-width: 640px) {
      left: 280px; /* Expanded sidebar width */
      width: calc(100% - 280px);

      .modal-content {
        margin-left: auto;
        margin-right: auto;
      }

      .modal-bg {
        left: -280px;
        width: calc(100% + 280px);
      }
    }
  }

  /* El asistente acoplado a la derecha (420px, AssistantBubble.vue) queda
     visible y usable con el modal abierto */
  &.assistant-docked {
    @media (min-width: 641px) {
      width: calc(100% - 420px);

      &.sidebar-open {
        width: calc(100% - 280px - 420px);
      }
    }
  }

  @media (max-width: 639px) {
    padding: 0px;
    padding-top: 0px;

    &.sidebar-open {
      left: 0;
      width: 100%;
    }
  }

  /* Full page mode: render as a normal in-flow page instead of an overlay */
  &.full-page {
    display: block;
    position: static;
    padding: 0;
    background-color: transparent;
    width: 100%;
    height: auto;
    min-height: 100vh;

    &.sidebar-open {
      left: 0;
      width: 100%;

      > .modal-content {
        margin-left: 0;
        margin-right: 0;
      }
    }

    // Direct child only: nested modals (e.g. sync/product modals opened on
    // top of a full-page order) must keep their own centered .modal-content.
    > .modal-content {
      box-shadow: none;
      border-radius: 0;
      min-height: 100vh;
      max-height: none;
      margin: 0;

      > .content {
        padding: 20px;

        @media (max-width: 767px) {
          padding: 12px;
        }
      }
    }
  }
}

.active {
  display: block !important;
}
/* Modal Content */
.modal-content {
  background-color: #fefefe;
  margin: auto;
  box-shadow: 5px 15px 5px #00000063;
  border-radius: 3px;
  min-height: 300px;
  max-height: 90vh;
  position: relative;
  width: 100%;
  overflow: visible;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  .header {
    position: sticky;
    top: 0;
    z-index: 60;
    left: 0px;
    width: 100%;
    min-height: 30px;
    padding: 10px 20px;
    height: auto;
    flex-shrink: 0;
    color: white;
    display: grid;
    grid-template-columns: 1fr 50px;

    &.hasinfo {
      box-sizing: border-box;
      background-color: #e5e5e5;
      min-height: 60px;

      @media (max-width: 767px) {
        min-height: auto;
        height: auto;
        max-height: none;
        padding: 8px 12px;
        flex-shrink: 0;
        overflow: visible;
      }

      @media (max-width: 390px) {
        min-height: auto;
        height: auto;
        max-height: none;
        padding: 6px 8px;
        flex-shrink: 0;
        overflow: visible;
      }
    }

    @media (max-width: 767px) {
      padding: 8px 12px;
      grid-template-columns: 1fr 40px;
    }

    @media (max-width: 390px) {
      padding: 6px 8px;
      grid-template-columns: 1fr 35px;
    }

    .info {
      height: 100%;
      align-content: center;
      color: black;

      @media (max-width: 767px) {
        align-content: flex-start;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        min-height: auto;
        height: auto;
        max-height: none;
        overflow: visible;
      }
    }
  }
  /* The Close Button */
  .close {
    color: #aaaaaa;
    font-size: 28px;
    font-weight: bold;
    position: absolute;
    right: 15px;
    top: 5px;

    @media (max-width: 767px) {
      font-size: 24px;
      right: 12px;
      top: 8px;
    }

    @media (max-width: 390px) {
      font-size: 20px;
      right: 8px;
      top: 6px;
    }
  }
  .close:hover,
  .close:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
  }
}
</style>
